var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTakeOutPaid = function SvgTakeOutPaid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM16 26.6667C21.891 26.6667 26.6667 21.891 26.6667 16C26.6667 10.109 21.891 5.33333 16 5.33333C10.109 5.33333 5.33333 10.109 5.33333 16C5.33333 21.891 10.109 26.6667 16 26.6667ZM16 28.4444C22.8729 28.4444 28.4444 22.8729 28.4444 16C28.4444 9.12712 22.8729 3.55556 16 3.55556C9.12712 3.55556 3.55556 9.12712 3.55556 16C3.55556 22.8729 9.12712 28.4444 16 28.4444ZM22.5905 11.1874C23.2847 11.8818 23.2846 13.0074 22.5903 13.7016L14.2211 22.0698L9.40944 17.2569C8.71525 16.5626 8.71539 15.437 9.40974 14.7428C10.1041 14.0486 11.2297 14.0487 11.9239 14.7431L14.2216 17.0413L20.0763 11.1873C20.7706 10.4931 21.8963 10.4931 22.5905 11.1874Z",
    fill: "currentColor"
  })));
};
export default SvgTakeOutPaid;